<div class="px-4 py-1" ref="manage_workflow">
  <!-- <NavigationBackButton /> -->

  <div class="card-header card-header-primary shadow-2 rounded-lg mt-3">
    <div class="nav-tabs-navigation">
      <div class=" nav nav-tabs-wrapper">
        <p class="p-2 text-white mb-0 text-x fw-bold">Requested Information From {{requester_name}}</p>
      </div>
    </div>
  </div>
  <div class="border-0 mt-2">

    <div class="card-body rounded-lg glassy-bg rounded-bottom-0">
      <!-- Message Card -->
      <div class="card mb-3 border-0 shadow-sm hover-card gray-background rounded-lg">
        <div class="card-body px-3 py-2 shadow-sm">
          <p class="text-x mt-3"><span class="fw-bold">Request note:</span> {{ request_note }}</p>
          <div class="text-end text-xs text-muted"><span class="fw-bold">Date:</span> {{ date_requested }}</div>
        </div>
      </div>
      <!-- Documents Card -->

      <div v-if="has_submitted_response" class="text-xs mt-5 glassy-bg  p-3 rounded-lg">
        <p class="fw-bold mb-2">Submitted response</p>

        <div class="table-responsive">
          <table class="table table-hover align-middle">
            <thead class="card-bg text-white">
              <tr>
                <th class="text-xxs">No</th>
                <th class="text-xxs">Document Name</th>
                <th class="text-xxs">Date Uploaded</th>
                <th class="text-xxs">Review Status</th>
                <th class="text-xxs">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(doc, index) in submitted_response" :key="index">
                <td>{{ index + 1 }}</td>
                <td class="text-truncate">{{ doc.document_name }}</td>
                <td>{{ doc.date_created }}</td>
                <td>
                  <span
                    class="badge px-2 py-1"
                    :class="{
                      'bg-success text-white': doc.response_accepted,
                      'bg-danger text-white': doc.response_rejected,
                      'bg-secondary text-white': !doc.response_accepted && !doc.response_rejected
                    }"
                  >
                    {{ doc.review_status }}
                  </span>
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-primary-dark btn-sm text-xxs shadow"
                    @click="open_document(doc)"
                  >
                    View
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="fields_needing_reupload.length || (!has_submitted_response && fields.length)" class="glassy-bg mt-4 border-2 rounded-lg">
        <div class="card-body px-3 py-2">

          <div v-if="has_rejected_response" class="alert alert-danger text-xxs mb-3 mt-2">
            One or more uploaded documents were rejected. Please upload corrected files.
          </div>

          <div class="mt-3" v-for="(field, index) in (fields_needing_reupload.length ? fields_needing_reupload : fields)" :key="index">
            <div class="mb-3">
              <div class="d-flex align-items-center mb-2">
                <i class="fa-regular fa-file me-2"></i>
                <label class="text-xxs">{{ field.label }}</label>
              </div>
              <input
                type="file"
                class="form-control text-xs rounded-small shadow-sm"
                @change="handle_file_change($event, index)"
              />
              <div v-if="file_validation_error[index]" class="text-danger text-xxs mt-1">
                {{ file_validation_error[index] }}
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-end">
            <button type="submit" class="btn btn-primary-dark btn-sm text-xxs shadow mt-0" @click="submit_response">
              Submit
            </button>
          </div>

        </div>
      </div>

      <div v-else-if="!has_submitted_response && !fields.length">
        <p class="text-xs mt-3 fw-bold">Please update the above requested fields on your application</p>
      </div>

      <div v-else-if="!has_submitted_response && !fields.length">
        <p class="text-xs mt-3 fw-bold">Please update the above requested fields on your application</p>
      </div>

      <div v-else-if="!has_submitted_response && !fields.length">
        <p class="text-xs mt-3 fw-bold">Please update the above requested fields on your application</p>
      </div>
    </div>
  </div>
</div>
<div v-if="preview_modal"  @click.self="preview_modal = false">
  <FilePreviewComponent :presigned_url="selected_file.presigned_url" @close="close_the_file_preview"
    :key="selected_file.presigned_url" />
</div>